import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__ from "@base-ui-components/react/popover";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__ from "../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__ScrollArea_index_js_9ae635af__ from "../ScrollArea/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Text_index_js_2dd71991__ from "../Text/index.js";
function PopoverContent({ headingCustomSlot, headingCloseButtonSlot, headingLeftSlot, headingRightSlot, headingTextSlot, headingIconSlot, bodyTextSlot, renderCloseButton, headingCustomNode, headingText, headingIconName, headingRightNode, description, children, footer, headingClasses, scrollAreaClasses, contentClasses, bodyClasses, footerClasses }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: contentClasses,
        children: [
            headingCustomNode ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Title, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    className: headingCustomSlot,
                    children: headingCustomNode
                })
            }) : headingText ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: headingClasses,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: headingLeftSlot,
                        children: [
                            headingIconName && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                                iconName: headingIconName,
                                size: "24",
                                className: headingIconSlot
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Title, {
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    className: headingTextSlot,
                                    children: headingText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: headingRightSlot,
                        children: headingRightNode
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: headingCloseButtonSlot,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Close, {
                            render: ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    children: renderCloseButton()
                                })
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__ScrollArea_index_js_9ae635af__.ScrollArea, {
                className: scrollAreaClasses,
                popoverBody: true,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_popover_cdb87929__.Popover.Description, {
                        className: bodyClasses,
                        children: [
                            description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Text_index_js_2dd71991__.Span, {
                                className: bodyTextSlot,
                                children: description
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: footerClasses,
                        children: footer
                    })
                ]
            })
        ]
    });
}
export { PopoverContent };
